export const environment = {
  production: true,
  apiUrl: 'https://staging.api.boof.io',
  googleAppId: 'boofio-d4f66',
  googleClientId: '91954131035-p5m08ea4qvhagv9cl6k97ijnmc2fhavl.apps.googleusercontent.com',
  googleApiKey: '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',
  facebookAppId: '980110948711931',
  // Must match API GOOGLE_CALLBACK_URL and an Authorized redirect URI in Google Cloud (same string).
  googleRedirectUri: 'https://staging.boof.io/auth/google/callback',
};
